import React from 'react';
import './ImageStyleSheet.css';

function ImageInkThree() {
    window.scrollTo(0,0);
    return (
        <div className="container">
            <img src="/images/7ink3.jpg" className='img-view'/>
        </div>
    )
}

export default ImageInkThree
